
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/telegram",
      function () {
        return require("private-next-pages/auth/telegram/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/telegram"])
      });
    }
  